__turbopack_context__.v({
  "avatar-wrapper": "styles-module__obaqSG__avatar-wrapper",
  "full-width-child": "styles-module__obaqSG__full-width-child",
  "podium-link-wrapper": "styles-module__obaqSG__podium-link-wrapper",
  "shadow-wrapper-list-item": "styles-module__obaqSG__shadow-wrapper-list-item",
});
